<template>
  <v-container class="max-width-1200">

    <v-row>
      <v-col class="pb-0 headline text-uppercase">
        {{ $t('career.apply.title') }}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="display-1">
        {{ $t('career.apply.subtitle')}}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-justify">
        {{ $t('career.apply.text.01')}} <strong class="mouse-hover-link" @click="openMail('karrier@rubin.hu')">karrier@rubin.hu</strong> {{ $t('career.apply.text.02')}}
      </v-col>
    </v-row>

    <!-- <v-row justify="center">
      <v-col>
        <v-text-field
          v-model="name"
          outlined filled
          dark
          :label="$t('common.name')">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-text-field
          v-model="email"
          outlined filled
          dark
          :label="$t('common.email')">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-textarea
          v-model="message"
          outlined filled
          dark
          :label="$t('common.message')">
        </v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-file-input
          v-model="files"
          counter
          outlined filled
          dark
          label="Csatolmány"
          hint="Önéletrajzod mindenképpen csatold. Motivációs leveled, fotód, és okleveleid beküldésével gyorsíthatod a kiválasztás folyamatát!"
          persistent-hint
          multiple
          :show-size="1000"
          class="pt-0">
          <template v-slot:selection="{ index, text }">
            <v-chip
              v-if="index < 2"
              color="primary"
              dark
              label
              small>
                {{ text }}
            </v-chip>
            <span
              v-else-if="index === 2"
              class="overline grey--text text--lighten-2 mx-2">
                +{{ files.length - 2 }} fájl
            </span>
          </template>
        </v-file-input>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="pt-12 text-end">
        <v-btn text dark>Küldés</v-btn>
      </v-col>
    </v-row> -->

        <!-- reCaptcha -->
        <!-- <vue-recaptcha sitekey="Your key here">
          <button>Click me</button>
        </vue-recaptcha> -->

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Apply',
    extends: DataComponentBase,

    data: () => ({
      name: "",
      email: "",
      message: "",
      files: [],

    }),

    methods: {
      openMail(email) {
        window.location ='mailto:' + email;
      },
    },
  }
</script>
